import {connect} from 'react-redux';
import ComparableItemSummaryAug2020Container from './ComparableItemSummaryAug2020';
import * as ComparableSalesActions from 'actionCreators/comparableSales';
import * as ComparableListingsActions from 'actionCreators/comparableListings';
import * as ComparableRentalsActions from 'actionCreators/comparableRentals';
import AnalyticsGateway from 'lib/AnalyticsGateway';
import {getIn} from 'lib/immutableObject';
import {getMarkers} from 'lib/MapUtil';

const duckies = {
  'Comparable Sales': {
    duck: ComparableSalesActions,
    type: 'Sales',
  },
  'Comparable Listings': {
    duck: ComparableListingsActions,
    type: 'Listings',
  },
  'Comparable Rentals': {
    duck: ComparableRentalsActions,
    type: 'Rentals',
  },
};

const comparableItemData = (featureFlags) => {
  return {
    'Comparable Sales': {
      /* I'm not certain which comparable sales box they will want displayed in production,
      so prefer the latest component and work down through the LD flags to the previous versions
       */
      component: ComparableItemSummaryAug2020Container,
    },
    'Comparable Listings': {
      component: ComparableItemSummaryAug2020Container,
    },
    'Comparable Rentals': {
      component: ComparableItemSummaryAug2020Container,
    },
  };
};

const mapStateToProps = (state, {propertyId, pageContext}) => {

  const type = duckies[pageContext].type;

  const comparableItems = {
    'Comparable Sales': state.comparableSales,
    'Comparable Listings': state.comparableListings,
    'Comparable Rentals': state.comparableRentals,
  };

  const marker = getMarkers(state, type.toLowerCase()).find(({id}) => id === propertyId);

  return {
    Component: comparableItemData(state.featureFlags)[pageContext].component,
    property: comparableItems[pageContext].properties[propertyId],
    markerLabel: marker ? marker.label : null,
    showMarker: !!marker,

    pageContext: pageContext,
    featureFlags: state.featureFlags,

    // analytics
    reportType: state.reportType.value,
    targetPropertyId: getIn(state, ['propertyDetail', 'propertyId']),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const duck = duckies[ownProps.pageContext].duck;

  return {
    onImageSelect: (selectedImageIndex) => {
      dispatch(duck.updateForSession({
        propertyId: ownProps.propertyId,
        keyPath: 'propertyPhotoUriSelectedIndex',
        value: selectedImageIndex,
      }, true));
    },
    onUpload: (files) => dispatch(duck.uploadComparableImage(ownProps.propertyId, files[0])),
    onDelete: (currentImageIndex) => dispatch(duck.deleteUploadedImage(ownProps.propertyId, currentImageIndex)),
    onRemoveSelected: (propertyId) => dispatch(duck.removeSelectedItem(propertyId)),
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onImageSelect: (selectedImageIndex) => {
      dispatchProps.onImageSelect(selectedImageIndex);

      AnalyticsGateway.sendEvent({
        eventName: 'Select Property Photo',
        properties: [
          {label: 'Page', value: ownProps.pageContext},
          {label: 'Comparable Property ID', value: ownProps.propertyId},
          {label: 'Property ID', value: stateProps.targetPropertyId},
          {label: 'Report Type', value: stateProps.reportType},
          {label: 'Object Context', value: ownProps.pageContext},
        ],
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
  ({Component, ...props}) => <Component {...props}/>);
